import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import NavbarLink from "./NavbarLink";
import {
    NavDropdown,
    ListGroup,
    Accordion,
    Card,
    Button
} from "react-bootstrap";

const Reports = ({ CanI }) => {
    const [state, setState] = useState({
        reports_csv_overlay: false,
        reports_tasks: false,
        reports_files_tab_view: false,
        preseizure_view_dashboard: false,
        preseizure_view_order_line_item_assignment_list: false,
        title_view_dashboard: false,
        usms_view_dashboard: false,
        customer_service_view_dashboard: false,
        property_operations_view_dashboard: false,
        sso_dashboard_view: false
    });

    useEffect(() => {
        async function InitReports() {
            setState({
                ...state,
                reports_csv_overlay: await CanI("reports_csv_overlay"),
                reports_tasks: await CanI("reports_tasks"),
                reports_files_tab_view: await CanI("reports_files_tab_view"),
                preseizure_view_dashboard: await CanI(
                    "preseizure_view_dashboard"
                ),
                preseizure_view_order_line_item_assignment_list: await CanI(
                    "preseizure_view_order_line_item_assignment_list"
                ),
                title_view_dashboard: await CanI(
                    "title_view_dashboard"
                ),
                usms_view_dashboard: await CanI(
                    "usms_view_dashboard"
                ),
                customer_service_view_dashboard: await CanI(
                    "customer_service_view_dashboard"
                ),
                property_operations_view_dashboard: await CanI(
                    "property_operations_view_dashboard"
                ),
                sso_dashboard_view: await CanI("sso_dashboard_view")
            });
        }
        InitReports();
    }, []);
    const {
        reports_tasks,
        reports_csv_overlay,
        reports_files_tab_view,
        preseizure_view_dashboard,
        preseizure_view_order_line_item_assignment_list,
        title_view_dashboard,
        usms_view_dashboard,
        customer_service_view_dashboard,
        property_operations_view_dashboard,
        sso_dashboard_view
    } = state;
    return (
        <NavDropdown.ItemText>
            <ListGroup>
                <ListGroup.Item>
                    <NavbarLink
                        to="/app/reports#reports"
                        className="dropdown-item"
                        label={`Exports`}
                    />
                </ListGroup.Item>

                {reports_csv_overlay && (
                    <ListGroup.Item>
                        <NavbarLink
                            to="/app/reports#overlays"
                            className="dropdown-item"
                            label={`Overlays`}
                        />
                    </ListGroup.Item>
                )}
                {reports_files_tab_view && (
                    <ListGroup.Item>
                        <NavbarLink
                            to="/app/reports#reports_files"
                            className="dropdown-item"
                            label={`Templates`}
                        />
                    </ListGroup.Item>
                )}
                {reports_tasks && (
                    <ListGroup.Item>
                        <NavbarLink
                            to="/app/reports/tasks"
                            className="dropdown-item"
                            label={`Tasks`}
                        />
                    </ListGroup.Item>
                )}
            </ListGroup>

            {(preseizure_view_dashboard || title_view_dashboard || customer_service_view_dashboard || usms_view_dashboard || property_operations_view_dashboard || sso_dashboard_view) && (
                <Accordion>
                    <Card>
                        <Card.Header>
                            <Accordion.Toggle
                                as={Button}
                                variant="light"
                                eventKey="dashboard-toggle-list"
                            >
                                <span
                                    className="text-dark"
                                    id={"dashboard-toggle-list"}
                                >
                                    Dashboards
                                </span>
                            </Accordion.Toggle>
                        </Card.Header>

                        <Accordion.Collapse eventKey="dashboard-toggle-list">
                            <Card.Body className="p-0">
                                <ListGroup>
                                    {preseizure_view_dashboard && (
                                        <ListGroup.Item>
                                            <NavbarLink
                                                to="/app/preseizure"
                                                className="dropdown-item"
                                                label={`Pre-Seizure`}
                                            />
                                        </ListGroup.Item>
                                    )}
                                    {title_view_dashboard && (
                                        <ListGroup.Item>
                                            <NavbarLink
                                                to="/app/title"
                                                className="dropdown-item"
                                                label={`Title`}
                                            />
                                        </ListGroup.Item>
                                    )}
                                    {customer_service_view_dashboard && (
                                        <ListGroup.Item>
                                            <NavbarLink
                                                to="/app/customer-service"
                                                className="dropdown-item"
                                                label={`Customer Service`}
                                            />
                                        </ListGroup.Item>
                                    )}
                                    {usms_view_dashboard && (
                                        <ListGroup.Item>
                                            <NavbarLink
                                                to="/app/usms-dashboard"
                                                className="dropdown-item"
                                                label={`USMS Dashboard`}
                                            />
                                        </ListGroup.Item>
                                    )}
                                    {property_operations_view_dashboard && (
                                        <ListGroup.Item>
                                            <NavbarLink
                                                to="/property-operations"
                                                className="dropdown-item"
                                                label={`Property Operations`}
                                            />
                                        </ListGroup.Item>
                                    )}
                                    {sso_dashboard_view && (
                                        <ListGroup.Item>
                                            <a
                                                href="/single-sign-on/dashboard"
                                                className="dropdown-item"
                                            >
                                                SSO Dashboard
                                            </a>
                                        </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            )}
        </NavDropdown.ItemText>
    );
};

Reports.propTypes = { CanI: PropTypes.func };

export default Reports;
